<template>
  <div class="product_detail">
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">FAQ Update</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link>/
      <b>Marketing</b>
      /
      <router-link to="/faq">
        <b>FAQ</b>
      </router-link>/
      <b>New</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="form-group">
      <label>Question:</label>
      <input class="form-control" v-model="faqs.question" />
    </div>

    <hr />

    <div class="form-group">
      <label>Answer:</label>

      <div id="app">
        <ckeditor :editor="editor" v-model="faqs.answer" :config="editorConfig"></ckeditor>
      </div>
    </div>

    <hr />

    <div class="form-group">
      <label>Type:</label>
      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          id="type1"
          name="type"
          value="1"
          checked="checked"
          v-model="faqs.type"
        />
        <label class="form-check-label" for="type1">General</label>
      </div>
      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          id="type2"
          name="type"
          value="2"
          v-model="faqs.type"
        />
        <label class="form-check-label" for="type2">Loyalty Points</label>
      </div>
    </div>

    <hr />

    <div class="form-group">
      <label>Status:</label>
      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          id="active1"
          name="active"
          value="1"
          checked="checked"
          v-model="faqs.active"
        />
        <label class="form-check-label" for="active1">Active</label>
      </div>
      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          id="active2"
          name="active"
          value="0"
          v-model="faqs.active"
        />
        <label class="form-check-label" for="active2">Inactive</label>
      </div>
    </div>

    <input type="submit" class="btn btn-primary mb-2" @click="save()"/>
  </div>
</template>

<script>
import axios from "axios";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { global } from "@/global";

export default {
  name: "faq_details",
  components: {
    ckeditor: CKEditor.component
  },
  data() {
    return {
      faqs: [],
      editor: ClassicEditor,
      editorConfig: {
        isReadOnly: true,
      }
    };
  },

  methods: {
    save() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;
        swal({
          icon: 'warning',
          text: 'Are you sure?',
          buttons: ['Cancel', 'Yes']
        }).then((confirm) => {
          if(!confirm) {
            return;
          }
          axios
            .post(axios.lpsURL + "/faq/store", 
            {
                id: this.id,
                question: this.faqs.question,
                answer: this.faqs.answer,
                type: this.faqs.type,
                active: this.faqs.active
            },
            {
              headers: {
                Authorization: "Bearer " + token
              }
            })
            .then(res => {
                if(res.data.success) {
                  swal({
                    icon: 'success',
                    text: res.data.message
                  })
                  .then(val => {
                      this.$router.push("/faq")
                  })
                } else {
                  swal({
                    icon: 'warning',
                    text: res.data.message
                  })
                }
            });

        })
      }
    }
  },

  computed: {},

  mounted() {
  }
};
</script>
